import React from 'react'

class WPEngineHeader extends React.Component {
	render() {
		return <div className="wpe">
			<div className="navbar justify-content-between">
				<a className="navbar-brand" href="https://wpengine.com/" target="_blank" rel="noopener noreferrer">
					<img src="/assets/wpengine/logo.svg" alt="WP Engine"/>
				</a>
				<div className="navbar-inner">
					<img src="/assets/wpengine/blogvault-logo.svg" alt="Powered by BlogVault"/>
				</div>
			</div>
		</div>
	}
}

export default WPEngineHeader
